import { AbstractDomComponent } from './AbstractDomComponent';

// Refers to the dom-elements and blocks to be rendered

export class AbstractTemplateElementComponent extends AbstractDomComponent {
    #parentNode;
    #insertBeforeNode;
    #elements;
    _needListeners = false;

    renderTo(parentNode, insertBeforeNode = null) {
        if (this.#elements && this.#elements.length > 0) {
            this.appendTo(parentNode, insertBeforeNode);

            return;
        }

        const elements = this._render(parentNode, insertBeforeNode);

        this.#parentNode = parentNode;
        this.#insertBeforeNode = insertBeforeNode;

        if (!(elements instanceof Array)) {
            throw new Error('Method _render must return an array of elements.');
        }

        this.#elements = elements;
    }

    appendTo(parentNode, insertBeforeNode) {
        if (!this.#elements || this.#elements.length < 1) {
            this.renderTo(parentNode, insertBeforeNode);

            return;
        }

        if (insertBeforeNode instanceof Node) {
            this.#elements.forEach((el) => {
                parentNode.insertBefore(el, insertBeforeNode);
            });
        } else {
            this.#elements.forEach((el) => {
                parentNode.appendChild(el);
            });
        }

        this.#parentNode = parentNode;
        this.#insertBeforeNode = insertBeforeNode;
    }

    hide(clear) {
        // Ignores the second parameter and remove elements anywhere
        super.hide(clear, true);
    }

    _prepareToShow() {
        if (!this.#parentNode || !this.#elements || this.#elements.length < 1) return;

        // Append them back
        this.appendTo(this.#parentNode, this.#insertBeforeNode);
    }

    _show() {
        if (!this.#elements) return;

        this.#elements.forEach((el) => {
            el.classList.add('active');
        });
    }

    _hide() {
        if (!this.#elements) return;

        this.#elements.forEach((el) => {
            el.classList.remove('active');
        });
    }

    _clear() {
        this.#elements = null;
        this.#parentNode = null;
        this.#insertBeforeNode = null;
    }

    // eslint-disable-next-line class-methods-use-this
    _render() {
        // Override this method completely to fulfill template rendering
        // PARAMETERS ORDER:
        // parentNode
        throw new Error('Method _render of AbstractTemplateElementComponent must be overridden.');
    }

    // eslint-disable-next-line class-methods-use-this
    _addListeners() {
        // Override this method to make elements interactive
    }

    // eslint-disable-next-line class-methods-use-this
    _removeListeners() {
        // Override this method to remove all the listeners associated
    }

    get parentNode() {
        return this.#parentNode;
    }

    get _elementsList() {
        return this.#elements || [];
    }
}
